export default __webpack_public_path__ + "static/Metropolis-ThinItalic-f720555c0f369c339dd86de11482a077.woff2";